import { Box, Grid, Typography, useMediaQuery } from '@mui/material'
import { useState } from 'react'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import InnerTab from './Tab'

import styles from './index.module.scss'
import InputCustom from '../../atoms/input/InputCustom'

export const WeddingTab = ({ isSidebarOpen, myKazoos, otherKazoos }) => {
	const [value, setValue] = useState(0)
	const isSmallScreen = useMediaQuery('(max-width:991px)')
	const [innerTab, setInnerTab] = useState(0)

	const handleChange = (event, newValue) => {
		setValue(newValue)
	}

	const [searchQuery, setSearchQuery] = useState('')

	function CustomTabPanel(props) {
		const { children, value, index, ...other } = props

		return (
			<div
				role="tabpanel"
				hidden={value !== index}
				id={`simple-tabpanel-${index}`}
				aria-labelledby={`simple-tab-${index}`}
				{...other}
			>
				{value === index && <Box>{children}</Box>}
			</div>
		)
	}
	const mainTabStyle = {
		'& .MuiTabs-scrollButtons.Mui-disabled': {
			opacity: '0.3',
		},
		'&.MuiTabs-root': {
			minHeight: 'unset',
		},
		'& .MuiButtonBase-root': {
			padding: '11px 16px',
			minHeight: 'unset',
			fontSize: '14px',
			fontFamily: 'Inter',
			fontWeight: '500',
			color: '#313131',
			textTransform: 'capitalize',
			'&.Mui-selected': {
				color: '#7CA6BD',

				'& svg path': {
					stroke: '#7CA6BD',
				},
			},
		},
		'& .MuiTabs-indicator': {
			backgroundColor: '#7CA6BD',
		},
		'@media (max-width: 599px)': {
			'& .MuiButtonBase-root': {
				padding: '8px',
			},
		},
	}
	const innerTabStyle = {
		'&.MuiTabs-root': {
			minHeight: 'unset',
			backgroundColor: '#F2F6F8',
			padding: '2px 4px',
			borderRadius: '10px',
		},
		'& .MuiTabs-scroller': {
			padding: '0',
		},

		'& .MuiButtonBase-root': {
			padding: '6px 8px',
			minHeight: 'unset',
			fontSize: '14px',
			fontFamily: 'Inter',
			fontWeight: '500',
			color: '#8692A4',
			textTransform: 'capitalize',
			minWidth: ' auto !important',

			'&.Mui-selected': {
				color: '#7CA6BD',
				backgroundColor: '#fff',
				borderRadius: '8px',
				boxShadow: '0px 1px 3px 0px #0000001A',
				minWidth: ' auto !important',

				'& svg path': {
					stroke: '#7CA6BD',
				},
			},
		},
		'& .MuiTabs-indicator': {
			backgroundColor: 'transparent',
		},
		'@media (max-width: 599px)': {
			'& .MuiButtonBase-root': {
				padding: '6px 8px',
			},
		},
	}

	const handleChangeInnerTab = (event, newValue) => {
		setInnerTab(newValue)
	}
	return (
		<>
			<section className={styles.tabSection}>
				<Box sx={{ width: '100%' }} className={styles.tabs}>
					<Box sx={{ borderBottom: 1, borderColor: '#DFE4EB' }}>
						<Tabs
							value={value}
							onChange={handleChange}
							aria-label="basic tabs example"
							sx={mainTabStyle}
							variant={isSmallScreen ? 'scrollable' : 'standard'}
							scrollButtons={isSmallScreen ? 'auto' : false}
							allowScrollButtonsMobile={isSmallScreen}
						>
							<Tab
								label={
									<div className={styles.tabItem}>
										<span data-cy="myWeddings">
											My Weddings
										</span>
									</div>
								}
							/>
							<Tab
								label={
									<div className={styles.tabItem}>
										<span data-cy="otherWeddings">
											Other Weddings
										</span>
									</div>
								}
							/>
						</Tabs>
					</Box>

					<div className={styles.tabContentWrp}>
						<Box sx={{ width: '100%' }} className={styles.mainTabs}>
							<Box className={styles.topRow}>
								{/* {ProposalCardBidData} */}
								<Grid container spacing={2}>
									<Grid size={{ xs: 12, sm: 4, md: 2.4 }}>
										<div className={styles.searchContainer}>
											<InputCustom
												type="text"
												name="search"
												id="search"
												placeholder="Search Wedding"
												error={false}
												searchIcon={true}
												value={searchQuery}
												onChange={(e) =>
													setSearchQuery(
														e.target.value
													)
												}
											/>
										</div>
									</Grid>
									<Grid size={{ xs: 12, sm: 8, md: 9.6 }}>
										<div className={styles.ctaRow}>
											<div className={styles.filterBtns}>
												<div className={styles.left}>
													<Tabs
														value={innerTab}
														onChange={
															handleChangeInnerTab
														}
														aria-label="basic tabs example"
														sx={innerTabStyle}
													>
														<Tab
															label={
																<div
																	className={`${styles.tabItem} ${innerTab === 0 ? styles.selected : ''}`}
																>
																	<img
																		src="/images/Grid.svg"
																		alt="Grid"
																	/>
																	<span>
																		Grid
																	</span>
																</div>
															}
														/>
														<Tab
															label={
																<div
																	className={`${styles.tabItem} ${innerTab === 1 ? styles.selected : ''}`}
																>
																	<img
																		src="/images/List.svg"
																		alt="List"
																	/>
																	<span>
																		List
																	</span>
																</div>
															}
														/>
													</Tabs>
												</div>
												{/* {hasFilter && (
                                                    <div className={styles.rightActions}>
                                                        <ButtonCustom
                                                            variant="outlined"
                                                            onClick={props.onClickFilter}
                                                            size="small"
                                                            style={{
                                                                minHeight: '40px',
                                                            }}
                                                        >
                                                            <img src="/images/filter.svg" />
                                                            <Typography variant="body">
                                                                Filter
                                                            </Typography>
                                                        </ButtonCustom>
                                                    </div>
                                                )} */}
											</div>
										</div>
									</Grid>
								</Grid>
							</Box>
						</Box>
						<CustomTabPanel
							value={value}
							index={0}
							className={styles.content}
						>
							{myKazoos?.length > 0 ? (
								<InnerTab
									isSidebarOpen={isSidebarOpen}
									kazoos={myKazoos}
									innerTab={innerTab}
									searchQuery={searchQuery}
									setSearchQuery={setSearchQuery}
								/>
							) : (
								<p>Not a part of any weddings</p>
							)}
						</CustomTabPanel>
						<CustomTabPanel
							value={value}
							index={1}
							className={styles.content}
						>
							{otherKazoos?.length > 0 ? (
								<InnerTab
									isSidebarOpen={isSidebarOpen}
									kazoos={otherKazoos}
									innerTab={innerTab}
									searchQuery={searchQuery}
									setSearchQuery={setSearchQuery}
								/>
							) : (
								<p>Not a part of any weddings</p>
							)}
						</CustomTabPanel>
					</div>
				</Box>
			</section>
		</>
	)
}
